import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-[#040a14] border-t border-border/30" data-id="element-85">
      <div className="container mx-auto px-4 text-center" data-id="element-86">
        <p className="text-white/40 text-sm" data-id="element-87">
          © {new Date().getFullYear()} Chef de Yates Internacionales — Todos
          los derechos reservados
        </p>
      </div>
    </footer>;
}